import { CommonModule } from '@angular/common';
import { AfterViewInit, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';
import { ListLinks } from '../../../@core/constants/list-links';
import { Material } from '../../../generated/generated-types';
import { MaterialEditWidgetComponent } from '../../../modules/materials/components/material-edit-widget/material-edit-widget.component';
import { GenericBaseModelDropDown } from '../../components/genericBaseModelDropDown';
import { MaterialService } from '../../services/material.service';

@Component({
  selector: 'app-material-drop-down',
  templateUrl: './material-drop-down.component.html',
  styleUrls: ['./material-drop-down.component.css'],
  providers: [MaterialService],
  standalone: true,
  imports: [
    CommonModule,
    TranslatePipe,
    TooltipModule,
  ]
})
export class MaterialDropDownComponent extends GenericBaseModelDropDown<Material> implements AfterViewInit {

  constructor(private service: MaterialService
  ) {
    super(service, "Material");
    this.createNewPopupComponent = MaterialEditWidgetComponent;
    this.listUrl.set(ListLinks.MATERIAL);
  }

}
